import ERP from "@apiV2/ERP.mjs";
import Schema from "@apiV2/Schema.mjs";
import {Status} from "@apiV2/enums/SolicitacaoDeOrcamentoEnum";

export default {

    async getOneById(solicitacaoDeOrcamentoID = ""){

        let solicitacaoDeOrcamento;

        try{

            solicitacaoDeOrcamento = await ERP.getOneById(Schema.SOLICITACAO_DE_ORCAMENTO, solicitacaoDeOrcamentoID);
            if(solicitacaoDeOrcamento.status != 200){
                throw solicitacaoDeOrcamento;
            }

            console.log(solicitacaoDeOrcamento);

        }catch(e){

            console.log(e);
            return solicitacaoDeOrcamento;

        }

        return solicitacaoDeOrcamento;

    },

    async alteraSolicitacaoDeOrcamento(solicitacaoDeOrcamentoValores = {}){

        let solicitacaoDeOrcamento;

        try{

            solicitacaoDeOrcamento = await ERP.patchOne(Schema.SOLICITACAO_DE_ORCAMENTO, solicitacaoDeOrcamentoValores);
            if(solicitacaoDeOrcamento.status != 200){
                throw solicitacaoDeOrcamento;
            }

            console.log(solicitacaoDeOrcamento);

        }catch(e){

            console.log(e);
            return solicitacaoDeOrcamento;

        }

        return solicitacaoDeOrcamento;

    },

    async removeJob(solicitacaoDeOrcamentoID = ""){

        let solicitacaoDeOrcamento;

        try{

            let solicitacaoDeOrcamentoValores = {
                id: solicitacaoDeOrcamentoID,
                job: "",
                status: Status.EM_EXECUCAO,
            }

            solicitacaoDeOrcamento = await ERP.patchOne(Schema.SOLICITACAO_DE_ORCAMENTO, solicitacaoDeOrcamentoValores);
            if(solicitacaoDeOrcamento.status != 200){
                throw solicitacaoDeOrcamento;
            }

            console.log(solicitacaoDeOrcamento);

        }catch(e){

            console.log(e);
            return solicitacaoDeOrcamento;

        }

        return solicitacaoDeOrcamento;

    },

}